import request from './request'

export const studentApi = {
  listStudent (params) {
    return request.get('/students', { params: params })
  },
  saveStudent (data) {
    return request.post('/student', data)
  },
  deleteStudent (id) {
    return request.delete('/students/' + id)
  },
  getStudent (id) {
    return request.get('/students/' + id)
  },
  updateStudent (id, data) {
    return request.put('/students/' + id, data)
  },
}

export default studentApi
